import { render, staticRenderFns } from "./ReferralCard.vue?vue&type=template&id=f8300f42&scoped=true"
import script from "./ReferralCard.vue?vue&type=script&lang=js"
export * from "./ReferralCard.vue?vue&type=script&lang=js"
import style0 from "./ReferralCard.vue?vue&type=style&index=0&id=f8300f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8300f42",
  null
  
)

export default component.exports